import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { push } from 'store/router/router-actions';
export const useHideSpotDetails = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const onSpotDetailsHidden = () => {
        const queryParams = new URLSearchParams(history.location.search);
        queryParams.delete('spot-id');
        dispatch(push(`${history.location.pathname}?${queryParams.toString()}`, {
            reload: false,
        }));
    };
    return onSpotDetailsHidden;
};
